import { map, get, find } from "lodash"
import { createSelector } from "reselect"
import { getPermissions, getFavoritesAsObject, getUploadingItems } from "./items"

const EMPTY_ARRAY = []
const getRawWatchlists = state => get(state, "global.data.accountWatchlists.data.watchlists", EMPTY_ARRAY)

export const getWatchlists = createSelector(
  [getRawWatchlists],
  (watchlists) =>
    map(watchlists, watchlist => {
      const info = []

      if (watchlist.count > 0) {
        info.push({ label: "Securities", value: watchlist.count })
      }

      return {
        ...watchlist,
        label: watchlist.name,
        resourceType: "watchlist",
        noData: watchlist.count === 0,
        info,
      }
    }),
)
export const getWatchlistsWithMeta = createSelector(
  [getWatchlists, getPermissions, getFavoritesAsObject, getUploadingItems],
  (watchlists, permissions, favorites, uploadingItems) => map(watchlists, watchlist => ({
    ...watchlist,
    ...find(permissions, ({ id }) => id === watchlist.id),
    shortType: "watchlist",
    type: "Watchlist",
    isFavorite: get(favorites, watchlist.id, false),
    refresh: get(uploadingItems, watchlist.id, false),
  })),
)
